import { gql, DocumentNode } from '@apollo/client';

export interface GetCourseStatsQueryVariables {
  courseId: string;
}

export interface GetCourseStatsQueryResult<TCourseStats> {
  courseStats: TCourseStats;
}

export const getCourseStatsQuery = (fragment: DocumentNode) => gql`
  query GetCourseStatsQuery($courseId: String!) {
    courseStats(courseId: $courseId) @rest(type: "CourseStats", path: "courses/{args.courseId}/stats") {
      ...CourseStats
    }
  }
  ${fragment}
`;
